var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapemainsection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 323.641,
    height: 566.667,
    viewBox: "0 0 323.641 566.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 566.667,
    height: 323.641,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape_main_section",
    "data-name": "Shape main section",
    transform: "translate(0 566.667) rotate(-90)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M0,.474A.474.474,0,1,1,.474.948.474.474,0,0,1,0,.474Z",
    transform: "translate(443.458 2.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(-153.956 -149.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(1.064 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(689.97 111.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M34.916,0A.145.145,0,0,1,35,.025.143.143,0,0,1,35.045.2L5.533,65.9a.142.142,0,0,1-.119.082.135.135,0,0,1-.129-.065l0,0a.12.12,0,0,1-.019-.052L0,34.887a.138.138,0,0,1,.039-.122L34.817.042A.142.142,0,0,1,34.916,0ZM5.465,65.367,34.475.78.291,34.911Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(695.231 111.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M29.654,0a.143.143,0,0,1,.093.035L50.4,18.006a.141.141,0,0,1,.048.1.137.137,0,0,1-.044.1L.263,65.915a.14.14,0,0,1-.11.067.135.135,0,0,1-.129-.065l0,0a.14.14,0,0,1,.009-.162L29.526.083a.145.145,0,0,1,.1-.08A.129.129,0,0,1,29.654,0ZM50.1,18.118,29.7.372.57,65.236Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(668.094 145.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M.14,0H.147L22.023.92a.143.143,0,0,1,.11.062.14.14,0,0,1,.016.125L6.8,45.3a.139.139,0,0,1-.053.093.142.142,0,0,1-.229-.117L0,.161A.137.137,0,0,1,.037.046.141.141,0,0,1,.14,0ZM21.822,1.193.3.288l6.416,44.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(622.47 145.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M45.764,0a.136.136,0,0,1,.094.036.139.139,0,0,1,.015.193L.264,55.294a.14.14,0,0,1-.155.071A.141.141,0,0,1,0,55.228a.159.159,0,0,1,.026-.087l8.9-18a.14.14,0,0,1,.026-.036L45.665.042A.136.136,0,0,1,45.764,0ZM.806,54.2,43.64,2.484,9.171,37.287Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(622.47 145.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M45.764,0A.137.137,0,0,1,45.9.119l6.525,45.146a.141.141,0,0,1-.112.158L.166,55.366a.136.136,0,0,1-.116-.03A.138.138,0,0,1,0,55.228a.147.147,0,0,1,.033-.093L45.656.051A.141.141,0,0,1,45.764,0ZM52.13,45.173,45.67.473.493,55.018Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(532.157 203.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M50.379,0a.14.14,0,0,1,.131.188L35.109,43.9a.141.141,0,0,1-.24.067L.037,6.183a.143.143,0,0,1-.028-.145.137.137,0,0,1,.115-.09L50.362,0ZM34.916,43.609,50.171.307.43,6.194Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(509.865 209.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M22.432,0a.164.164,0,0,1,.046.007.141.141,0,0,1,.093.15L14.726,67.928a.14.14,0,0,1-.256.089.087.087,0,0,1-.014-.025L.012,36.64a.143.143,0,0,1,.009-.133L22.313.066A.141.141,0,0,1,22.432,0ZM14.5,67.421,22.219.757.3,36.59Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(524.309 209.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M7.988,0a.141.141,0,0,1,.1.045l34.83,37.79a.136.136,0,0,1,.037.109.138.138,0,0,1-.06.1L.222,68.054a.136.136,0,0,1-.106.024.139.139,0,0,1-.091-.061A.141.141,0,0,1,0,67.92L7.848.125a.14.14,0,0,1,.1-.118A.149.149,0,0,1,7.988,0ZM42.607,37.907,8.092.461.315,67.646Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(418.625 265.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M52.364,0a.144.144,0,0,1,.1.045A.144.144,0,0,1,52.5.17L40.163,59.321a.159.159,0,0,1-.015.067.149.149,0,0,1-.238.027l-.015-.022L.03,7.385a.139.139,0,0,1-.019-.139.141.141,0,0,1,.111-.085L52.345,0ZM39.944,58.994,52.187.307.4,7.406Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(404.003 272.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M14.763,0h.011A.14.14,0,0,1,14.9.1l15.394,55.53a.142.142,0,0,1-.113.176h0a.141.141,0,0,1-.112-.029L.052,31.408a.142.142,0,0,1-.039-.17L14.635.08A.14.14,0,0,1,14.763,0ZM29.9,55.288,14.728.543.314,31.259Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(418.625 272.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M.141,0A.144.144,0,0,1,.252.054L40.134,52.082a.139.139,0,0,1,.018.138.136.136,0,0,1-.11.085l-24.492,3.5a.143.143,0,0,1-.158-.117l0-.015L0,.178A.141.141,0,0,1,.078.015.139.139,0,0,1,.141,0ZM39.764,52.062.469.8,15.635,55.514Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(365.047 303.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M39.1,0a.137.137,0,0,1,.1.046.138.138,0,0,1,.033.127L26.341,53.217a.142.142,0,0,1-.166.1.139.139,0,0,1-.1-.09L.018,5.658a.138.138,0,0,1,0-.13.139.139,0,0,1,.106-.076L39.077,0ZM26.154,52.8,38.911.308.361,5.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(316.536 309.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M48.652,0a.141.141,0,0,1,.126.2L20.074,55.96a.141.141,0,0,1-.227.064L.048,38.487a.139.139,0,0,1,.006-.216L48.565.03A.14.14,0,0,1,48.652,0ZM19.9,55.691,48.232.652.36,38.388Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(336.335 309.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M28.852,0a.141.141,0,0,1,.124.073l26.065,47.59a.14.14,0,0,1-.1.206L.161,56.058a.135.135,0,0,1-.1-.027A.133.133,0,0,1,0,55.938a.151.151,0,0,1,.013-.089L28.728.076A.144.144,0,0,1,28.851,0ZM54.7,47.621,28.857.441.388,55.739Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(287.277 347.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M29.4,0a.141.141,0,0,1,.14.127l5.044,52.119a.143.143,0,0,1-.048.134.141.141,0,0,1-.19-.009l-.018-.021L.024,2.5A.141.141,0,0,1,.13,2.282L29.389,0Zm4.853,51.743L29.273.292.394,2.543Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(316.536 347.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M.14,0A.144.144,0,0,1,.234.036l19.8,17.535a.14.14,0,0,1,.035.161L5.314,52.327a.139.139,0,0,1-.1.082.142.142,0,0,1-.127-.038.145.145,0,0,1-.04-.087L0,.155A.142.142,0,0,1,.14,0ZM19.77,17.715.315.483,5.271,51.711Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(263.802 349.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M23.615,0a.128.128,0,0,1,.042.007.139.139,0,0,1,.1.135l-.4,69.268a.138.138,0,0,1-.047.1.123.123,0,0,1-.107.035H23.2a.142.142,0,0,1-.1-.063L.023,34.57a.139.139,0,0,1,0-.156L23.5.062A.141.141,0,0,1,23.615,0ZM23.08,68.954,23.472.6.31,34.493Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(286.874 349.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M.543,0A.141.141,0,0,1,.659.061l34.3,49.85a.135.135,0,0,1,.02.111.146.146,0,0,1-.067.091L.239,69.515a.133.133,0,0,1-.106.034H.127a.139.139,0,0,1-.121-.18L.4.14A.141.141,0,0,1,.5.007.128.128,0,0,1,.543,0Zm34.1,49.943L.681.589.288,69.165Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(189.675 401.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M46.32,0a.141.141,0,0,1,.107.049.138.138,0,0,1,.011.167L4.757,64.895a.142.142,0,0,1-.191.044A.139.139,0,0,1,4.5,64.8L0,20.956a.139.139,0,0,1,.082-.142L46.262.013A.134.134,0,0,1,46.32,0ZM4.74,64.4,45.946.464.291,21.029Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(166.981 422.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M22.834,0a.144.144,0,0,1,.076.022.139.139,0,0,1,.064.129L18.016,58.1a.141.141,0,0,1-.127.128.133.133,0,0,1-.148-.1v0L.01,13.014a.141.141,0,0,1,.062-.174L22.765.018A.136.136,0,0,1,22.834,0ZM17.787,57.479,22.672.393.316,13.025Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(184.716 422.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M5.1,0a.141.141,0,0,1,.14.126L9.74,44a.145.145,0,0,1-.024.093L.272,58.142a.142.142,0,0,1-.117.088.133.133,0,0,1-.148-.1v0a.133.133,0,0,1,0-.07L4.96.128A.14.14,0,0,1,5.1,0ZM9.455,43.976,5.112,1.64.328,57.554Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(128.025 435.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M39.1,0a.141.141,0,0,1,.138.169L27.708,58.286a.14.14,0,0,1-.237.072l0,0L.027,19.876A.138.138,0,0,1,0,19.761a.147.147,0,0,1,.073-.092L39.033.015A.156.156,0,0,1,39.1,0ZM27.5,57.914,38.9.4.35,19.846Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(155.451 435.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M11.67,0A.142.142,0,0,1,11.8.089L29.535,45.212a.14.14,0,0,1-.073.18L.23,58.369a.129.129,0,0,1-.046.025.14.14,0,0,1-.139-.036l0,0A.145.145,0,0,1,0,58.23a.293.293,0,0,1,.01-.033L11.533.113A.141.141,0,0,1,11.658,0ZM29.225,45.189,11.715.638.335,58.015Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(70.109 455.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M58.056,0a.136.136,0,0,1,.1.038.138.138,0,0,1,.021.18L26.468,47.931a.141.141,0,0,1-.117.063.108.108,0,0,1-.038-.006L.125,45.13a.14.14,0,0,1-.071-.251L57.971.029A.145.145,0,0,1,58.056,0ZM26.283,47.7,57.466.775.5,44.888Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(96.318 455.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M31.847,0a.143.143,0,0,1,.115.058L59.388,38.52a.14.14,0,0,1,.015.136.139.139,0,0,1-.107.085L.189,47.986a.159.159,0,0,1-.047.008.143.143,0,0,1-.112-.056l0,0a.142.142,0,0,1,.013-.183L31.73.063A.143.143,0,0,1,31.845,0Zm27.18,38.5L31.852.388.438,47.663Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(618.353 100.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M61.206,0a.14.14,0,0,1,.136.174L50.019,45.387a.148.148,0,0,1-.024.05l0,0a.138.138,0,0,1-.175.04L.077,20.5A.141.141,0,0,1,.1,20.244L61.161.007A.162.162,0,0,1,61.206,0ZM49.788,45.151,61.008.354.506,20.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(668.093 100.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M11.466,0h0A.14.14,0,0,1,11.6.109L22.154,46.246a.137.137,0,0,1-.029.12.134.134,0,0,1-.114.051L.135,45.5a.139.139,0,0,1-.12-.081.13.13,0,0,1,0-.11L11.33.106A.141.141,0,0,1,11.466,0ZM21.839,46.129,11.46.743.32,45.222Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(585.997 120.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M32.5,0a.135.135,0,0,1,.043.007.144.144,0,0,1,.1.106L45.667,62.156a.14.14,0,0,1-.083.158.138.138,0,0,1-.147-.024L.06,29.912A.14.14,0,0,1,0,29.806a.144.144,0,0,1,.046-.112L32.4.037A.141.141,0,0,1,32.5,0ZM45.318,61.861,32.41.411.363,29.784Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(618.353 120.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M.14,0A.137.137,0,0,1,.2.016L49.945,24.994a.144.144,0,0,1,.075.1.137.137,0,0,1-.039.12L13.288,62.266a.13.13,0,0,1-.061.048.138.138,0,0,1-.171-.052h0a.155.155,0,0,1-.024-.063L0,.17A.14.14,0,0,1,.14,0Zm49.5,25.158L.338.4,13.257,61.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(548.22 150.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M37.917,0A.136.136,0,0,1,38,.028a.139.139,0,0,1,.056.121l-3.6,53.008a.142.142,0,0,1-.091.122.14.14,0,0,1-.148-.033h0L.035,14.221A.141.141,0,0,1,0,14.094.144.144,0,0,1,.092,14L37.869.008A.145.145,0,0,1,37.917,0ZM34.2,52.8,37.762.347.381,14.19Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(582.394 150.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M3.743,0a.137.137,0,0,1,.082.026L49.213,32.412a.141.141,0,0,1-.028.244L.208,53.27l-.018.009a.14.14,0,0,1-.148-.033h0A.144.144,0,0,1,0,53.125L3.6.13A.14.14,0,0,1,3.743,0Zm45.1,32.494L3.866.4.3,52.929Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(526.273 164.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M22.087,0a.144.144,0,0,1,.107.048.141.141,0,0,1,.026.139L6.162,45.152a.143.143,0,0,1-.119.093H6.037a.143.143,0,0,1-.153-.119L0,4.6a.14.14,0,0,1,.111-.159L22.06,0A.11.11,0,0,1,22.087,0Zm-16,44.536L21.871.328.3,4.7Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(532.157 164.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M16.2,0a.146.146,0,0,1,.107.048L50.484,39.067a.141.141,0,0,1,.025.143.137.137,0,0,1-.115.089L.168,45.244H.154A.142.142,0,0,1,0,45.121a.147.147,0,0,1,.024-.1L16.072.093A.137.137,0,0,1,16.178,0,.108.108,0,0,1,16.2,0ZM50.1,39.051,16.256.414.354,44.939Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(495.874 168.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M30.54,0a.141.141,0,0,1,.137.17L14.271,77.12a.134.134,0,0,1-.014.046.144.144,0,0,1-.173.071.138.138,0,0,1-.093-.118L0,19.83a.142.142,0,0,1,.061-.152L30.464.024A.133.133,0,0,1,30.54,0ZM14.123,76.472,30.332.443.3,19.861Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(509.864 168.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M16.55,0h0a.141.141,0,0,1,.134.12l5.884,40.523a.144.144,0,0,1-.019.093L.262,77.178a.142.142,0,0,1-.173.058A.141.141,0,0,1,0,77.077L16.413.112A.141.141,0,0,1,16.55,0Zm5.737,40.634L16.523.937.449,76.334Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(452.76 188.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M43.255,0a.146.146,0,0,1,.084.028.142.142,0,0,1,.049.156L18.364,77.342a.149.149,0,0,1-.139.1.139.139,0,0,1-.13-.106v0L.009,29.575a.141.141,0,0,1,.052-.166L43.176.025A.141.141,0,0,1,43.255,0ZM18.22,76.874,42.994.488.312,29.578Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(470.849 188.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M25.166,0h0A.139.139,0,0,1,25.3.107L39.294,57.415a.143.143,0,0,1-.073.158L.226,77.41a.18.18,0,0,1-.09.028.139.139,0,0,1-.13-.106v0a.136.136,0,0,1,.01-.094L25.032.1A.141.141,0,0,1,25.166,0ZM38.994,57.373,25.146.655.381,77.017Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(418.625 217.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M34.276,0a.138.138,0,0,1,.082.027.141.141,0,0,1,.037.188L.265,55.147a.138.138,0,0,1-.182.052l0,0A.14.14,0,0,1,0,55.044L3.893,35.76a.143.143,0,0,1,.03-.063L34.168.049A.141.141,0,0,1,34.276,0ZM.43,54.349,33.154,1.68,4.161,35.852Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(418.625 217.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M34.276,0h.013a.138.138,0,0,1,.117.09L52.5,47.863a.14.14,0,0,1-.01.121.141.141,0,0,1-.1.067L.192,55.207A.147.147,0,0,1,.083,55.2l0,0A.14.14,0,0,1,0,55.048a.146.146,0,0,1,.043-.08L34.157.066A.14.14,0,0,1,34.276,0Zm17.9,47.8L34.245.456.424,54.891Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(403.305 253.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M19.35,0a.143.143,0,0,1,.092.035.14.14,0,0,1,.039.154L.975,50.616a.136.136,0,0,1-.074.092.142.142,0,0,1-.157-.02A.138.138,0,0,1,.7,50.569L0,10.564a.141.141,0,0,1,.073-.126L19.284.018A.127.127,0,0,1,19.35,0ZM.966,49.826,19.091.442.282,10.644Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(404.002 253.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M18.653,0a.151.151,0,0,1,.038.006.142.142,0,0,1,.1.163L14.9,19.451.269,50.643a.136.136,0,0,1-.065.065.142.142,0,0,1-.157-.02.142.142,0,0,1-.038-.153L18.521.092A.14.14,0,0,1,18.653,0ZM1.38,47.611,14.635,19.364,18.153,1.912Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(338.218 263.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M65.227,0a.139.139,0,0,1,.112.057.14.14,0,0,1,0,.174L27.093,45.679a.142.142,0,0,1-.037.045.14.14,0,0,1-.163.007L.063,28.23A.137.137,0,0,1,0,28.1a.141.141,0,0,1,.084-.117L65.172.012A.136.136,0,0,1,65.227,0ZM26.94,45.426,64.738.5.437,28.139Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(365.047 263.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M38.4,0a.144.144,0,0,1,.14.138l.7,40.022a.142.142,0,0,1-.121.142L.159,45.752a.15.15,0,0,1-.152-.094.145.145,0,0,1,.025-.138L38.29.051A.142.142,0,0,1,38.4,0Zm.555,40.04L38.264.518.48,45.424Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(305.842 291.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M32.517,0a.138.138,0,0,1,.09.033.139.139,0,0,1,.042.158L10.967,55.932a.131.131,0,0,1-.033.048h0a.147.147,0,0,1-.134.037.138.138,0,0,1-.1-.1L.006,20.093a.141.141,0,0,1,.061-.16L32.444.02A.143.143,0,0,1,32.517,0ZM10.852,55.45,32.235.479.306,20.116Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(316.536 291.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M21.822,0A.139.139,0,0,1,21.9.024l26.829,17.5a.138.138,0,0,1,.063.111.14.14,0,0,1-.053.116L.228,55.992a.142.142,0,0,1-.192-.017.144.144,0,0,1-.022-.154L21.692.09a.137.137,0,0,1,.088-.083A.141.141,0,0,1,21.822,0Zm26.59,17.651L21.891.353.459,55.452Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(277.022 311.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M28.959,0a.139.139,0,0,1,.091.034A.14.14,0,0,1,29.086.2L10.521,38.315a.14.14,0,0,1-.178.07.136.136,0,0,1-.082-.087L.018,20.481A.14.14,0,0,1,.06,20.3L28.879.026A.132.132,0,0,1,28.959,0ZM10.385,37.951,28.6.57.326,20.452Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(287.276 311.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M18.705,0h.012a.139.139,0,0,1,.122.1l10.7,35.828a.141.141,0,0,1-.124.18L.183,38.388a.128.128,0,0,1-.093,0,.139.139,0,0,1-.084-.169v0a.144.144,0,0,1,.016-.036L18.579.079A.141.141,0,0,1,18.705,0ZM29.216,35.843,18.674.526.376,38.092Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(258.955 332.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M18.208,0a.138.138,0,0,1,.09.033.14.14,0,0,1,.046.143L5.131,52.366a.142.142,0,0,1-.149.106H4.976a.141.141,0,0,1-.127-.125L0,8.169a.141.141,0,0,1,.082-.144L18.151.012A.132.132,0,0,1,18.208,0ZM5.044,51.56,18,.385.291,8.24Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(263.802 332.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M13.36,0a.139.139,0,0,1,.121.07L23.737,17.91a.138.138,0,0,1-.007.149L.28,52.377a.131.131,0,0,1-.146.094H.128a.141.141,0,0,1-.108-.212L13.224.106a.141.141,0,0,1,.117-.1ZM23.45,17.973,13.411.511.481,51.585Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(216.445 340.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M42.649,0a.136.136,0,0,1,.089.031.14.14,0,0,1,.043.158L19.686,61.916A.145.145,0,0,1,19.6,62h0a.139.139,0,0,1-.167-.065L.018,26.775a.141.141,0,0,1,.048-.188L42.575.021A.136.136,0,0,1,42.649,0ZM19.528,61.537,42.373.479.328,26.756Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(235.855 340.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M23.24,0h.018a.14.14,0,0,1,.121.124L28.227,44.3a.14.14,0,0,1-.064.135L.235,61.974A.143.143,0,0,1,.189,62h0a.138.138,0,0,1-.171-.073.138.138,0,0,1,.011-.139L23.109.091A.141.141,0,0,1,23.24,0Zm4.7,44.247L23.165.743.423,61.525Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(151.12 366.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M65.465,0a.139.139,0,0,1,.107.051.139.139,0,0,1,.02.151L38.827,56.149a.135.135,0,0,1-.089.088A.138.138,0,0,1,38.6,56.2L.043,18.991A.135.135,0,0,1,0,18.856a.136.136,0,0,1,.1-.1L65.426.006A.158.158,0,0,1,65.465,0ZM38.652,55.866,65.2.362.413,18.957Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(189.675 366.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M26.911,0a.139.139,0,0,1,.122.073l19.41,35.161a.14.14,0,0,1,.01.112.138.138,0,0,1-.075.083L.2,56.231a.136.136,0,0,1-.144-.016A.14.14,0,0,1,0,56.08a.159.159,0,0,1,.012-.04L26.784.081A.142.142,0,0,1,26.908,0ZM46.124,35.236,26.92.447.433,55.818Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(121.041 385.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M30.221,0a.139.139,0,0,1,.03,0,.142.142,0,0,1,.1.094L46.22,50.136a.14.14,0,0,1-.03.137.141.141,0,0,1-.135.042h0L.089,32.4A.14.14,0,0,1,0,32.3a.142.142,0,0,1,.034-.127L30.117.044A.143.143,0,0,1,30.221,0ZM45.864,49.942,30.159.411.384,32.217Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(151.12 385.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M.141,0a.142.142,0,0,1,.1.039L38.793,37.253a.136.136,0,0,1,.042.118.144.144,0,0,1-.07.106L16.1,50.282a.134.134,0,0,1-.126.033h0a.139.139,0,0,1-.108-.116l0-.013L.006.182A.141.141,0,0,1,.067.02.144.144,0,0,1,.141,0ZM38.462,37.324.442.626,16.088,49.968Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(80.705 417.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M40.476,0a.147.147,0,0,1,.065.016.146.146,0,0,1,.073.1l6.98,37.539a.14.14,0,0,1-.188.174L.085,17.675a.141.141,0,0,1,0-.258L40.42.011A.14.14,0,0,1,40.476,0Zm6.8,37.466L40.369.338.5,17.544Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(121.04 417.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M.141,0a.16.16,0,0,1,.05.009L46.133,17.914a.141.141,0,0,1,.012.256L7.189,37.824a.143.143,0,0,1-.2-.1L0,.166A.137.137,0,0,1,.051.033.132.132,0,0,1,.141,0Zm45.6,18.061L.325.363l6.9,37.126Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(70.109 434.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M10.736,0a.113.113,0,0,1,.038.006.139.139,0,0,1,.1.157l-10.6,65a.139.139,0,0,1-.156.117A.14.14,0,0,1,0,65.131l4.03-49.1a.177.177,0,0,1,.009-.043L10.606.087A.141.141,0,0,1,10.736,0ZM.569,61.642,10.4,1.318,4.308,16.075Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(70.109 434.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M10.736,0a.134.134,0,0,1,.055.011l47.32,20.153a.138.138,0,0,1,.084.111.14.14,0,0,1-.053.129L.227,65.253A.14.14,0,0,1,0,65.12l10.6-65a.137.137,0,0,1,.071-.1A.129.129,0,0,1,10.736,0ZM57.781,20.329,10.847.339.337,64.813Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(604.989 53.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M40.109,0a.144.144,0,0,1,.081.026.142.142,0,0,1,.049.167l-26.6,66.851a.14.14,0,0,1-.2.1.148.148,0,0,1-.075-.091L.011,35.211a.14.14,0,0,1,.037-.161L40.015.035A.143.143,0,0,1,40.109,0ZM13.5,66.648,39.761.63.309,35.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(618.35 53.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M26.748,0a.141.141,0,0,1,.112.057L61.323,46.7a.14.14,0,0,1,.02.126.138.138,0,0,1-.089.091L.188,67.157a.144.144,0,0,1-.179-.187L26.616.089A.142.142,0,0,1,26.729,0ZM60.981,46.714,26.785.427.381,66.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(564.495 88.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M40.634,0a.144.144,0,0,1,.089.03.143.143,0,0,1,.046.151L21.774,61.712a.141.141,0,0,1-.272-.01L.018,22.594a.139.139,0,0,1,.054-.19L40.566.017A.146.146,0,0,1,40.634,0ZM21.606,61.306,40.4.432.33,22.581Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(585.995 88.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M19.134,0a.14.14,0,0,1,.129.085L32.627,31.952a.14.14,0,0,1-.034.158L.257,61.749a.143.143,0,0,1-.157.056.142.142,0,0,1-.093-.176l0-.007h0L19,.1a.141.141,0,0,1,.128-.1Zm13.2,31.97L19.154.551.43,61.21Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(544.672 111.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M19.964,0a.134.134,0,0,1,.065.017A.139.139,0,0,1,20.1.182L3.823,53.308a.141.141,0,0,1-.274-.024L0,25.047a.137.137,0,0,1,.029-.106L19.854.053A.144.144,0,0,1,19.964,0ZM3.747,52.6,19.612.807.287,25.07Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(548.22 111.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M16.416,0a.138.138,0,0,1,.122.073l21.5,39.138a.142.142,0,0,1-.074.2L.189,53.4a.143.143,0,0,1-.145-.03.139.139,0,0,1-.038-.143L16.281.1A.145.145,0,0,1,16.4,0Zm21.3,39.2L16.453.5.358,53.036Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(502.719 136.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M42.094,0a.141.141,0,0,1,.123.209L23.82,32.892a.139.139,0,0,1-.111.071.141.141,0,0,1-.048,0L.131,31.369a.14.14,0,0,1-.073-.253L42.01.027A.139.139,0,0,1,42.094,0ZM23.62,32.675,41.648.645.531,31.114Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(526.273 136.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M18.54,0l.027,0a.142.142,0,0,1,.112.12l3.549,28.238a.141.141,0,0,1-.112.155L.2,32.953a.131.131,0,0,1-.055.011.141.141,0,0,1-.11-.053l0,0a.141.141,0,0,1-.022-.136.172.172,0,0,1,.027-.046L18.417.071A.141.141,0,0,1,18.54,0Zm3.393,28.266L18.453.58.417,32.621Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(450.632 165.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M.141,0h0L52.231,1.317a.143.143,0,0,1,.111.06.144.144,0,0,1,.019.125l-6.844,21.25a.14.14,0,0,1-.134.1h0a.144.144,0,0,1-.085-.028L.078.265A.137.137,0,0,1,0,.106.139.139,0,0,1,.141,0Zm51.9,1.594L.769.3,45.3,22.507Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(495.874 167.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M6.986,0h.009L30.549,1.592a.14.14,0,0,1,.067.257L.242,21.49a.14.14,0,0,1-.1.042h0a.14.14,0,0,1-.134-.1v0a.144.144,0,0,1,.009-.11L6.852.1A.141.141,0,0,1,6.986,0ZM30.109,1.844,7.086.289.4,21.054Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(425.583 165.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M25.189,0a.136.136,0,0,1,.043.007.143.143,0,0,1,.1.128L27.45,52.042a.143.143,0,0,1,0,.1.135.135,0,0,1-.154.081.149.149,0,0,1-.075-.037L.056,31.764a.14.14,0,0,1-.026-.2L25.079.053A.137.137,0,0,1,25.189,0Zm1.97,51.793L25.064.523.34,31.625Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(450.632 165.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M.141,0A.133.133,0,0,1,.2.015L45.446,22.579a.14.14,0,0,1,.076.117.139.139,0,0,1-.061.126L2.348,52.205a.134.134,0,0,1-.1.021.149.149,0,0,1-.121-.134L0,.146A.14.14,0,0,1,.064.022.132.132,0,0,1,.141,0ZM45.105,22.724.29.372l2.1,51.462Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(382.003 197.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M43.72,0A.138.138,0,0,1,43.8.028a.143.143,0,0,1,.056.12L40.8,56.233a.14.14,0,0,1-.127.132h-.006a.135.135,0,0,1-.112-.04L.041,15.786a.142.142,0,0,1,.053-.233L43.673.008A.174.174,0,0,1,43.72,0ZM40.534,55.909,43.568.344.4,15.743Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(422.515 197.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M3.208,0a.136.136,0,0,1,.084.028L30.47,20.465a.144.144,0,0,1,.055.1.139.139,0,0,1-.033.106L.271,56.289a.136.136,0,0,1-.111.075H.154a.137.137,0,0,1-.138-.075.143.143,0,0,1-.008-.111L3.068.133A.141.141,0,0,1,3.208,0ZM30.182,20.6,3.334.411.309,55.809Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(372.152 212.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M9.992,0H10a.141.141,0,0,1,.118.085l21.3,50.958a.138.138,0,0,1,0,.106v0a.139.139,0,0,1-.107.085.137.137,0,0,1-.129-.045L.036,15.954a.142.142,0,0,1-.015-.169L9.873.066A.14.14,0,0,1,9.992,0ZM30.841,50.377,9.966.445.315,15.846Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(382.004 212.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M.14,0a.141.141,0,0,1,.1.042L40.75,40.581a.14.14,0,0,1-.031.222L21.509,51.224a.139.139,0,0,1-.161-.018.144.144,0,0,1-.044-.074L.011.2A.142.142,0,0,1,.061.024.146.146,0,0,1,.14,0ZM40.42,40.646.545.744,21.512,50.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(319.752 228.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M52.54,0a.141.141,0,0,1,.125.208L18.743,63.386a.137.137,0,0,1-.04.071.14.14,0,0,1-.158.024.152.152,0,0,1-.074-.084l0-.007L.012,20.582a.136.136,0,0,1,0-.109A.148.148,0,0,1,.09,20.4L52.489.01A.131.131,0,0,1,52.54,0ZM18.618,63.026,52.236.41.328,20.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(338.215 228.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M34.077,0a.144.144,0,0,1,.106.047L65.336,35.288a.144.144,0,0,1,.031.125.139.139,0,0,1-.082.1L.2,63.483a.144.144,0,0,1-.118,0A.152.152,0,0,1,.007,63.4a.149.149,0,0,1,.008-.11L33.953.074A.141.141,0,0,1,34.061,0ZM65,35.329,34.106.385.45,63.07Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(282.773 249.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M37.12,0A.136.136,0,0,1,37.2.027a.139.139,0,0,1,.055.144L23.351,62.911a.142.142,0,0,1-.065.092.15.15,0,0,1-.112.012h-.006a.147.147,0,0,1-.082-.065L.019,22.115a.139.139,0,0,1,.05-.19L37.048.02A.14.14,0,0,1,37.12,0ZM23.154,62.5,36.912.426.33,22.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(305.841 249.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M14.053,0a.142.142,0,0,1,.129.085L32.647,42.913a.138.138,0,0,1-.055.174L.247,62.98A.2.2,0,0,1,.218,63a.15.15,0,0,1-.112.012H.1A.142.142,0,0,1,0,62.9a.139.139,0,0,1,.017-.085L13.916.11A.139.139,0,0,1,14.039,0ZM32.341,42.912,14.1.6.356,62.583Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(248.536 270.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M34.378,0a.145.145,0,0,1,.082.026.141.141,0,0,1,.058.127l-5.75,61.093a.141.141,0,0,1-.26.074L.021,16.142a.142.142,0,0,1-.016-.115.139.139,0,0,1,.075-.088L34.319.012A.147.147,0,0,1,34.378,0ZM28.525,60.82,34.215.371.345,16.126Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(277.022 270.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M5.891,0a.141.141,0,0,1,.123.071L29.081,40.906a.138.138,0,0,1-.042.183L.221,61.359a.145.145,0,0,1-.146.01A.141.141,0,0,1,0,61.245v-.019L5.752.127A.14.14,0,0,1,5.863,0,.12.12,0,0,1,5.891,0ZM28.774,40.933,5.989.6.308,60.955Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(213.353 286.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M35.323,0a.1.1,0,0,1,.031,0,.141.141,0,0,1,.107.109L45.873,53.282a.138.138,0,0,1,.007.078.139.139,0,0,1-.16.111L.119,46.486a.141.141,0,0,1-.091-.224L35.212.055A.141.141,0,0,1,35.323,0ZM45.564,53.162,35.245.474.4,46.245Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(248.536 286.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M.14,0A.142.142,0,0,1,.259.065L28.746,45.243a.14.14,0,0,1-.062.2L10.616,53.459a.143.143,0,0,1-.2-.1L0,.167A.139.139,0,0,1,.088.01.14.14,0,0,1,.14,0ZM28.421,45.256.423.852l10.238,52.28Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(170.177 333.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M43.317,0a.14.14,0,0,1,.139.128l3.1,33.548a.139.139,0,0,1-.076.138l0,0a.138.138,0,0,1-.143-.01L.06,1.59a.141.141,0,0,1,.076-.256L43.312,0Zm2.929,33.407L43.189.285.569,1.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(213.353 333.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M.141,0,.162,0l45.6,6.984a.139.139,0,0,1,.117.11.142.142,0,0,1-.063.147L3.321,33.8l-.021.013,0,0a.143.143,0,0,1-.185-.057.138.138,0,0,1-.017-.091L0,.154A.144.144,0,0,1,.044.038.145.145,0,0,1,.141,0ZM45.346,7.207.3.307,3.356,33.448Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(151.12 334.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M19.2,0a.142.142,0,0,1,.131.19L.277,51.144a.157.157,0,0,1-.018.039.144.144,0,0,1-.182.048A.14.14,0,0,1,0,51.071L6.447,9.566A.139.139,0,0,1,6.5,9.475L19.115.028A.143.143,0,0,1,19.2,0ZM.491,49.768,18.9.541,6.716,9.664Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(151.119 334.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M19.2,0a.138.138,0,0,1,.08.026L65.546,32.242a.139.139,0,0,1-.04.249L.188,51.239a.143.143,0,0,1-.111-.007.143.143,0,0,1-.069-.174L19.066.091a.139.139,0,0,1,.091-.084A.129.129,0,0,1,19.2,0ZM65.144,32.3,19.266.36.37,50.894Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(110.704 343.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M47,0a.138.138,0,0,1,.1.043A.14.14,0,0,1,47.127.2L10.6,73.854a.139.139,0,0,1-.125.079h0a.141.141,0,0,1-.138-.114L0,21.9a.138.138,0,0,1,.079-.154L46.942.013A.139.139,0,0,1,47,0ZM10.534,73.363,46.7.436.3,21.956Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(121.04 343.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M36.666,0a.135.135,0,0,1,.042.007.14.14,0,0,1,.1.155L30.359,41.681a.139.139,0,0,1-.036.074L.258,73.87a.137.137,0,0,1-.115.062h0a.142.142,0,0,1-.115-.224L36.54.078A.14.14,0,0,1,36.666,0ZM30.089,41.6l6.3-40.577L.695,72.993Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(73.594 365.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M37.251,0a.146.146,0,0,1,.09.031A.142.142,0,0,1,37.38.2l-30,69.327a.141.141,0,0,1-.27-.061L0,25.551a.139.139,0,0,1,.06-.138L37.171.025A.142.142,0,0,1,37.251,0ZM7.313,68.966,36.929.532.294,25.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(80.704 365.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M30.141,0h.015a.142.142,0,0,1,.124.112L40.615,52.029a.139.139,0,0,1-.082.156L.228,69.578A.141.141,0,0,1,0,69.432v-.007a.105.105,0,0,1,.015-.033L30.013.084A.14.14,0,0,1,30.141,0ZM40.317,51.973,30.092.609.413,69.192Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(58.374 390.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M15.361,0a.136.136,0,0,1,.047.009.14.14,0,0,1,.093.13l.544,59.821a.135.135,0,0,1,0,.047.14.14,0,0,1-.273,0L.009,18.132a.138.138,0,0,1,.025-.14L15.254.049A.141.141,0,0,1,15.361,0Zm.4,59.18L15.224.519.3,18.11Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(73.595 390.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M.14,0A.139.139,0,0,1,.279.118l7.11,43.933a.148.148,0,0,1-.008.076L.815,60.028a.14.14,0,0,1-.15.1.147.147,0,0,1-.121-.147L0,.142A.139.139,0,0,1,.128,0ZM7.106,44.057.3,1.992l.52,57.294Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(604.986 27.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M40.618,0a.144.144,0,0,1,.1.038.142.142,0,0,1,.021.18L.262,61.458l0,0,0,0a.142.142,0,0,1-.193.037.139.139,0,0,1-.056-.161L5.08,26.42a.14.14,0,0,1,.054-.093l35.4-26.3A.141.141,0,0,1,40.618,0ZM.373,60.781,40.061.729,5.349,26.518Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(604.986 27.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M40.618,0a.133.133,0,0,1,.042.007.138.138,0,0,1,.1.136L40.252,26.37a.147.147,0,0,1-.048.1L.24,61.485a.146.146,0,0,1-.176.017.138.138,0,0,1-.04-.192L40.5.063A.14.14,0,0,1,40.618,0Zm-.647,26.3.5-25.681L.836,60.589Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(555.783 53.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M54.421,0a.14.14,0,0,1,.11.227L8.963,57.559a.141.141,0,0,1-.251-.088v0L0,10.466A.142.142,0,0,1,.115,10.3L54.4,0ZM8.935,57.142,54.076.348.3,10.551Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(564.495 53.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M45.709,0a.14.14,0,0,1,.139.161L40.773,35.1a.143.143,0,0,1-.071.1L.228,57.581a.137.137,0,0,1-.134.023A.142.142,0,0,1,0,57.471v0a.14.14,0,0,1,.044-.1L45.6.053A.135.135,0,0,1,45.709,0ZM40.5,34.993,45.5.635.691,57Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(528.257 64.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M27.667,0a.141.141,0,0,1,.065.017.139.139,0,0,1,.073.145L16.695,72.084a.141.141,0,0,1-.139.119.151.151,0,0,1-.139-.124v0L.008,25.781a.14.14,0,0,1,.037-.149L27.571.038A.138.138,0,0,1,27.667,0ZM16.5,71.488,27.466.518.3,25.774Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(544.672 64.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M11.252,0a.141.141,0,0,1,.137.115L20.1,47.144a.147.147,0,0,1-.028.114L.267,72.124A.142.142,0,0,1,.14,72.2.151.151,0,0,1,0,72.079v0a.139.139,0,0,1,0-.057L11.113.119A.14.14,0,0,1,11.249,0Zm8.562,47.132L11.265.98.362,71.554Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(484.876 89.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M43.521,0a.141.141,0,0,1,.1.042.139.139,0,0,1,.033.143L18.121,77.6a.14.14,0,0,1-.149.1h0a.142.142,0,0,1-.12-.1L.005,13.351a.142.142,0,0,1,.1-.173L43.481.006A.159.159,0,0,1,43.521,0ZM18,77.078,43.3.353.313,13.407Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(502.718 89.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M25.679,0a.138.138,0,0,1,.131.093L42.226,46.417a.141.141,0,0,1-.048.161L.252,77.645a.145.145,0,0,1-.123.047h0a.14.14,0,0,1-.12-.1.139.139,0,0,1,.018-.113L25.545.1a.14.14,0,0,1,.131-.1ZM41.927,46.413,25.684.574.42,77.171Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(441.871 102.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M43.146,0a.135.135,0,0,1,.083.028.141.141,0,0,1,.04.18L9.037,63.1a.142.142,0,0,1-.052.076.14.14,0,0,1-.174,0,.151.151,0,0,1-.045-.064L.012,43.7A.141.141,0,0,1,.04,43.54L43.046.042A.143.143,0,0,1,43.146,0ZM8.91,62.742,42.548.945.309,43.669Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(450.629 102.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M34.388,0H34.4a.137.137,0,0,1,.119.1L52.365,64.343a.136.136,0,0,1-.025.124.147.147,0,0,1-.113.054L.14,63.2a.139.139,0,0,1-.087-.033.144.144,0,0,1-.037-.178L34.265.073A.141.141,0,0,1,34.388,0ZM52.044,64.235,34.346.512.371,62.928Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(401.223 146.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M40.789,0A.142.142,0,0,1,40.9.055a.141.141,0,0,1,.021.128L24.639,51.1a.141.141,0,0,1-.264.035h0L.015,1.707A.138.138,0,0,1,.02,1.573.142.142,0,0,1,.136,1.5L40.784,0ZM24.473,50.7,40.594.288.363,1.778Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(425.583 146.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M16.428,0a.14.14,0,0,1,.128.083l8.76,19.423a.136.136,0,0,1-.018.145L.25,51.163a.134.134,0,0,1-.125.053.142.142,0,0,1-.111-.078.146.146,0,0,1-.008-.107L16.295.1a.143.143,0,0,1,.126-.1Zm8.6,19.545L16.451.532.507,50.389Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(377.959 147.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M23.4,0a.141.141,0,0,1,.135.181L4.32,65.16a.14.14,0,0,1-.134.1h0a.142.142,0,0,1-.134-.1v0L0,35.342a.141.141,0,0,1,.022-.1L23.287.063A.14.14,0,0,1,23.4,0ZM4.237,64.453,23,1,.288,35.356Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(382.004 147.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M19.36,0a.142.142,0,0,1,.127.079L43.846,49.509a.136.136,0,0,1,0,.115.139.139,0,0,1-.083.08L.219,65.238a.143.143,0,0,1-.078.024h0a.142.142,0,0,1-.134-.1v0a.134.134,0,0,1,.009-.1L19.226.1a.137.137,0,0,1,.122-.1ZM43.524,49.491,19.393.525.356,64.89Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(355.224 181.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M.141,0H.15L22.885,1.431a.141.141,0,0,1,.13.159L17.211,47.1a.141.141,0,0,1-.116.12h0a.143.143,0,0,1-.156-.091L.008.189A.14.14,0,0,1,.029.056.143.143,0,0,1,.141,0ZM22.718,1.7.345.294l16.66,46.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(372.151 183.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M5.948,0a.14.14,0,0,1,.139.121l4.044,29.795a.145.145,0,0,1-.02.093L.275,45.7a.139.139,0,0,1-.108.088h0a.147.147,0,0,1-.141-.061.141.141,0,0,1-.016-.125L5.809.122A.141.141,0,0,1,5.948,0Zm3.9,29.9L5.953,1.217.365,45.032Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(314.461 181.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M40.9,0a.141.141,0,0,1,.124.207L5.556,67.541a.141.141,0,0,1-.171.067.139.139,0,0,1-.093-.135L0,33.029A.14.14,0,0,1,.052,32.9L40.815.031A.145.145,0,0,1,40.9,0ZM5.507,67.031,40.462.678.292,33.066Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(319.752 181.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M35.613,0h.009a.14.14,0,0,1,.122.092L52.673,47.037a.141.141,0,0,1-.081.179L.223,67.59a.146.146,0,0,1-.129.019A.14.14,0,0,1,0,67.449v-.006a.141.141,0,0,1,.025-.056L35.488.075A.141.141,0,0,1,35.613,0ZM52.362,47,35.588.489.443,67.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(282.773 214.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M31.827,0a.139.139,0,0,1,.122.209L.268,56.579a.14.14,0,0,1-.167.065l0,0A.14.14,0,0,1,0,56.488L5.329,22.055a.139.139,0,0,1,.049-.087L31.737.031A.144.144,0,0,1,31.827,0ZM.4,55.779,31.331.735,5.6,22.151Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(282.773 214.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M31.827,0l.026,0a.141.141,0,0,1,.114.117l5.292,34.463a.138.138,0,0,1-.067.142L.243,56.612a.143.143,0,0,1-.143.033l0,0a.14.14,0,0,1-.1-.118.144.144,0,0,1,.04-.115L31.7.072A.142.142,0,0,1,31.827,0Zm5.14,34.532L31.751.564.529,56.116Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(229.135 236.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M59.108,0a.14.14,0,0,1,.11.227L19.656,50.59a.145.145,0,0,1-.1.054.14.14,0,0,1-.108-.042l0,0a.126.126,0,0,1-.026-.035L.015,12.719a.143.143,0,0,1,0-.125.138.138,0,0,1,.1-.076L59.079,0A.128.128,0,0,1,59.108,0ZM19.57,50.245,58.758.358.349,12.754Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(248.536 236.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M39.706,0a.159.159,0,0,1,.055.011.14.14,0,0,1,.083.151L34.517,34.594a.141.141,0,0,1-.08.106L.236,50.611a.152.152,0,0,1-.083.034A.14.14,0,0,1,.045,50.6l0,0A.138.138,0,0,1,0,50.475a.142.142,0,0,1,.056-.089L39.6.054A.137.137,0,0,1,39.706,0ZM34.25,34.478,39.485.65.625,50.119Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(197.024 249.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M32.251,0a.125.125,0,0,1,.056.012.141.141,0,0,1,.082.154L16.61,84.2a.142.142,0,0,1-.251.084.176.176,0,0,1-.028-.056L.01,42.267a.141.141,0,0,1,.019-.136L32.138.055A.142.142,0,0,1,32.251,0ZM16.421,83.68,32,.7.3,42.238Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(213.351 249.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M15.924,0a.141.141,0,0,1,.125.076l19.4,37.844a.143.143,0,0,1-.013.149L.254,84.277a.147.147,0,0,1-.221,0A.142.142,0,0,1,0,84.165L15.786.115A.141.141,0,0,1,15.9,0ZM35.16,37.97,15.986.57.388,83.637Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(161.726 286.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M.14,0H.16l35.3,4.831a.139.139,0,0,1,.108.08.141.141,0,0,1-.008.134L8.726,48.324a.145.145,0,0,1-.064.08A.141.141,0,0,1,8.5,48.39a.151.151,0,0,1-.053-.109L0,.164A.138.138,0,0,1,.039.043.141.141,0,0,1,.14,0ZM35.206,5.081.312.3,8.665,47.888Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(170.175 291.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M26.99,0H27a.142.142,0,0,1,.117.089L43.449,42.065a.14.14,0,0,1-.127.191L.147,43.59a.157.157,0,0,1-.094-.031.147.147,0,0,1-.034-.185L26.87.066A.142.142,0,0,1,26.99,0ZM43.115,41.982,26.961.454.395,43.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(138.77 286.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M23.1,0a.144.144,0,0,1,.074.02.141.141,0,0,1,.066.129l-4.16,57.587a.135.135,0,0,1-.042.09h0a.143.143,0,0,1-.126.039.14.14,0,0,1-.1-.083L.012,13.711a.141.141,0,0,1,.057-.176L23.025.019A.132.132,0,0,1,23.1,0ZM18.838,57.14,22.938.4.318,13.715Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(157.565 286.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M4.3,0a.139.139,0,0,1,.138.116l8.452,48.142a.14.14,0,0,1-.055.136L.224,57.84a.14.14,0,0,1-.19-.02A.142.142,0,0,1,0,57.706L4.162.13A.14.14,0,0,1,4.294,0Zm8.3,48.22L4.359,1.285.3,57.43Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(98.667 299.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M40.243,0a.135.135,0,0,1,.089.033A.139.139,0,0,1,40.372.2L12.311,66a.1.1,0,0,1-.019.031l0,.006a.146.146,0,0,1-.136.052.141.141,0,0,1-.109-.1L.006,27.608a.142.142,0,0,1,.055-.158L40.164.025A.145.145,0,0,1,40.243,0ZM12.2,65.543,39.925.528.3,27.622Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(110.704 299.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M28.206,0a.139.139,0,0,1,.129.085l18.8,44.071a.139.139,0,0,1-.07.182L.2,66.074a.141.141,0,0,1-.169-.039.139.139,0,0,1-.01-.162L28.078.085A.138.138,0,0,1,28.206,0ZM46.819,44.142,28.206.5.416,65.664Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(49.396 327.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M49.41,0a.144.144,0,0,1,.082.026.142.142,0,0,1,.05.166L24.475,63.942a.129.129,0,0,1-.037.069.144.144,0,0,1-.178.019.213.213,0,0,1-.034-.03L.047,42.6A.139.139,0,0,1,0,42.5a.142.142,0,0,1,.048-.106L49.319.034A.138.138,0,0,1,49.41,0ZM24.28,63.671,49.073.616.354,42.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(73.59 327.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M25.217,0h.006a.139.139,0,0,1,.128.1L37.389,38.479a.14.14,0,0,1-.054.158L.225,64.026a.129.129,0,0,1-.169.011.146.146,0,0,1-.045-.175L25.087.089A.14.14,0,0,1,25.217,0ZM37.09,38.465,25.2.563.44,63.542Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(16.392 369.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M33.145,0a.142.142,0,0,1,.137.109l8.973,39.342a.141.141,0,0,1-.048.157.14.14,0,0,1-.18-.01L.045.939A.139.139,0,0,1,.009.787.14.14,0,0,1,.137.7l33-.7Zm8.74,39.085L33.033.283.491.97Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(49.396 369.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M.141,0A.149.149,0,0,1,.234.035l24.2,21.414a.141.141,0,0,1,.014.2L9.225,39.587a.138.138,0,0,1-.124.048.14.14,0,0,1-.109-.078.166.166,0,0,1-.012-.034L0,.172A.139.139,0,0,1,.069.02.14.14,0,0,1,.141,0Zm24,21.569L.374.535,9.193,39.192Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(579.408 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M34.379,0a.14.14,0,0,1,.139.151L30.933,53.983a.137.137,0,0,1,0,.071.144.144,0,0,1-.225.07.156.156,0,0,1-.039-.046L.033,17.677A.14.14,0,0,1,0,17.559a.143.143,0,0,1,.074-.1L34.315.016A.142.142,0,0,1,34.379,0Zm-3.7,53.65L34.223.379.361,17.632Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(610.059 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M3.728,0A.143.143,0,0,1,3.82.035L35.638,27.608a.135.135,0,0,1,.048.111.139.139,0,0,1-.056.107L.23,54.126a.114.114,0,0,1-.044.021.14.14,0,0,1-.13-.024A.139.139,0,0,1,0,54.005L3.587.131a.141.141,0,0,1,.085-.12A.138.138,0,0,1,3.728,0ZM35.321,27.706,3.849.431.3,53.723Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(534.786 17.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M44.762,0a.142.142,0,0,1,.107.048A.14.14,0,0,1,44.888.2L21.271,46.91a.139.139,0,0,1-.233.055.135.135,0,0,1-.019-.024l-21-31.384a.139.139,0,0,1-.017-.122.146.146,0,0,1,.088-.089L44.717.008A.127.127,0,0,1,44.762,0ZM21.12,46.586,44.481.385.359,15.553Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(555.783 17.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M23.765,0a.142.142,0,0,1,.108.049L54.529,36.476a.141.141,0,0,1-.081.229L.167,47a.138.138,0,0,1-.126-.039A.144.144,0,0,1,.015,46.8L23.64.076A.141.141,0,0,1,23.749,0ZM54.159,36.473,23.795.393.393,46.675Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(521.013 32.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M13.914,0a.175.175,0,0,1,.042.006.141.141,0,0,1,.1.151L7.528,57.131a.139.139,0,0,1-.019.056l0,.006a.135.135,0,0,1-.143.066.14.14,0,0,1-.115-.107L0,26.289a.141.141,0,0,1,.012-.1L13.79.075A.137.137,0,0,1,13.914,0ZM7.339,56.31,13.689.868.289,26.275Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(528.257 32.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M6.669,0a.142.142,0,0,1,.117.062l21,31.387a.138.138,0,0,1-.021.18L.236,57.223a.14.14,0,0,1-.229-.145L6.53.124A.139.139,0,0,1,6.637,0,.152.152,0,0,1,6.669,0ZM27.483,31.505,6.765.536.326,56.757Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(471.2 58.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M49.954,0a.142.142,0,0,1,.122.073.14.14,0,0,1-.015.157L13.943,44.239a.135.135,0,0,1-.051.056.14.14,0,0,1-.211-.082L.008,6.509a.138.138,0,0,1,.012-.12.141.141,0,0,1,.1-.066L49.936,0ZM13.863,43.893,49.621.325.333,6.579Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(484.875 58.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M36.278,0a.1.1,0,0,1,.031,0,.141.141,0,0,1,.1.1l7.244,30.865a.138.138,0,0,1-.1.165L.183,44.312a.142.142,0,0,1-.14-.036.144.144,0,0,1-.011-.191L36.169.052A.141.141,0,0,1,36.278,0Zm7.076,30.908L36.207.449.538,43.909Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(423.289 65.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M48.052,0a.142.142,0,0,1,.073.02.141.141,0,0,1,.06.167L18.854,81.407a.143.143,0,0,1-.176.085.138.138,0,0,1-.09-.09L.021,51.747a.139.139,0,0,1,.017-.17L47.949.045A.137.137,0,0,1,48.052,0ZM18.688,81.035l29-80.294L.317,51.689Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(441.87 65.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M29.471,0A.142.142,0,0,1,29.6.092L43.279,37.807a.139.139,0,0,1-.031.147L.258,81.437a.141.141,0,0,1-.161.055.139.139,0,0,1-.091-.173l0-.006L.014,81.3,29.339.092A.141.141,0,0,1,29.471,0ZM42.985,37.82,29.471.553.491,80.8Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(385.412 116.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M38.017,0a.142.142,0,0,1,.112.055.142.142,0,0,1,0,.166L16.069,31.4l-.006.008a.141.141,0,0,1-.2.029.145.145,0,0,1-.035-.035L.036,13.91A.139.139,0,0,1,0,13.782a.142.142,0,0,1,.088-.1L37.97.008A.139.139,0,0,1,38.017,0ZM15.938,31.1,37.644.425.384,13.878Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(401.222 116.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M22.208,0h0a.14.14,0,0,1,.116.065L40.909,29.748a.14.14,0,0,1,.006.14.142.142,0,0,1-.119.074L.16,31.467a.135.135,0,0,1-.1-.026.139.139,0,0,1-.033-.193L22.093.06A.14.14,0,0,1,22.208,0ZM40.541,29.69,22.2.393.42,31.176Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(358.819 130.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M26.733,0a.135.135,0,0,1,.058.013.141.141,0,0,1,.081.147L19.421,52.834a.14.14,0,0,1-.239.1l-.007-.007L.035,30.961a.14.14,0,0,1,0-.184L26.627.048A.142.142,0,0,1,26.733,0Zm-7.55,52.507L26.528.593.327,30.868Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(377.959 130.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M7.594,0a.143.143,0,0,1,.1.046l15.81,17.511a.142.142,0,0,1,.013.172L.259,52.911a.14.14,0,0,1-.1.062.13.13,0,0,1-.114-.04.14.14,0,0,1-.04-.12L7.456.121a.138.138,0,0,1,.1-.115A.136.136,0,0,1,7.594,0ZM23.228,17.665,7.69.458.366,52.239Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(314.769 161.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M44.191,0a.142.142,0,0,1,.1.042.14.14,0,0,1,.037.122l-3.594,20.5v0a.143.143,0,0,1-.083.135.151.151,0,0,1-.125,0L.1,7.11A.14.14,0,0,1,.12,6.838L44.17,0Zm-3.71,20.488L44.019.309.729,7.028Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(355.219 161.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M3.74,0a.14.14,0,0,1,.107.048L22.986,22.013a.137.137,0,0,1,.02.154.14.14,0,0,1-.135.078L.147,20.816a.135.135,0,0,1-.09-.029A.142.142,0,0,1,0,20.653L3.6.116A.138.138,0,0,1,3.74,0ZM22.554,21.943,3.829.454.306,20.544Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(286.489 167.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M28.42,0a.133.133,0,0,1,.058.012.141.141,0,0,1,.082.129L28.255,46.7a.139.139,0,0,1-.1.132h0a.141.141,0,0,1-.133-.024L.053,24.46a.141.141,0,0,1,0-.217L28.329.034A.136.136,0,0,1,28.42,0Zm-.444,46.415.3-45.969L.361,24.347Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(314.46 167.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M.449,0A.158.158,0,0,1,.494.007L40.949,13.7a.141.141,0,0,1,.043.243L.246,46.8a.15.15,0,0,1-.057.036h0a.141.141,0,0,1-.169-.065.145.145,0,0,1-.014-.1L.309.139A.145.145,0,0,1,.367.025.141.141,0,0,1,.449,0ZM40.617,13.889.589.335l-.3,46.072Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(267.576 192.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M19.053,0a.139.139,0,0,1,.14.136l1.612,44.279a.141.141,0,0,1-.253.1L.028,16.674a.139.139,0,0,1,.021-.189L18.961.035A.141.141,0,0,1,19.053,0Zm1.455,43.981L18.924.439.331,16.612Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(286.489 192.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M.14,0A.139.139,0,0,1,.228.03L28.2,22.385a.136.136,0,0,1,.053.108.138.138,0,0,1-.05.11L1.843,44.539a.14.14,0,0,1-.229-.092l0-.016L0,.145A.142.142,0,0,1,.078.015.139.139,0,0,1,.14,0ZM27.889,22.5.292.442l1.59,43.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(210.518 208.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M57.2,0a.141.141,0,0,1,.1.238L18.88,40.563a.143.143,0,0,1-.136.072.147.147,0,0,1-.1-.053L.044,23.236A.14.14,0,0,1,0,23.108.138.138,0,0,1,.088,23L57.147.01A.141.141,0,0,1,57.2,0ZM18.747,40.294,56.65.514.4,23.181Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(229.131 208.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M38.587,0h.008a.138.138,0,0,1,.1.056L59.224,27.9a.136.136,0,0,1,.018.134.141.141,0,0,1-.1.087L.173,40.632a.172.172,0,0,1-.041,0,.145.145,0,0,1-.121-.09A.141.141,0,0,1,.037,40.4L38.485.044A.14.14,0,0,1,38.587,0ZM58.869,27.889,38.572.358.55,40.265Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(197.026 231.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M13.632,0a.136.136,0,0,1,.089.031.142.142,0,0,1,.048.14L.276,59.612a.124.124,0,0,1-.14.109A.142.142,0,0,1,0,59.6v0L.406,5.83A.139.139,0,0,1,.49,5.7L13.576.011A.136.136,0,0,1,13.632,0ZM.29,58.286,13.434.38.686,5.923Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(197.025 231.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M13.634,0a.138.138,0,0,1,.1.037L32.346,17.4a.14.14,0,0,1,.016.188L.267,59.643A.14.14,0,0,1,0,59.6v0a.141.141,0,0,1,.008-.072L13.5.109a.139.139,0,0,1,.1-.1A.169.169,0,0,1,13.634,0ZM32.062,17.517,13.716.409.422,58.976Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(159.835 237.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M37.737,0a.14.14,0,0,1,.114.223L2.157,49.118a.126.126,0,0,1-.14.076.14.14,0,0,1-.125-.127L0,27.735a.14.14,0,0,1,.056-.126L37.654.027A.134.134,0,0,1,37.737,0ZM2.138,48.668,37.089.79l-36.8,27Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(161.726 237.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M35.846,0a.148.148,0,0,1,.044.007.142.142,0,0,1,.1.135L35.58,53.888a.146.146,0,0,1-.048.106.155.155,0,0,1-.111.033L.121,49.193a.14.14,0,0,1-.1-.063.143.143,0,0,1-.017-.117.184.184,0,0,1,.023-.047L35.733.057A.138.138,0,0,1,35.846,0ZM35.3,53.726,35.7.575.391,48.947Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(118.409 264.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M41.566,0a.14.14,0,0,1,.12.212L20.625,35.059a.125.125,0,0,1-.021.027l0,0a.17.17,0,0,1-.106.04.137.137,0,0,1-.1-.049L.034,10.938a.14.14,0,0,1,.072-.227L41.531,0A.185.185,0,0,1,41.566,0ZM20.483,34.75,41.267.363.392,10.927Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(138.77 264.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M21.205,0a.152.152,0,0,1,.031,0,.142.142,0,0,1,.109.125L23.237,21.46a.142.142,0,0,1-.069.134L.212,35.11a.139.139,0,0,1-.182-.035.138.138,0,0,1,0-.172L21.085.069A.139.139,0,0,1,21.205,0Zm1.744,21.4L21.1.581.55,34.585Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(78.602 275.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M39.947,0a.14.14,0,0,1,.132.191L20.341,51.76a.139.139,0,0,1-.076.079.137.137,0,0,1-.111,0l0,0L.059,37.649a.138.138,0,0,1-.058-.1.142.142,0,0,1,.044-.113L39.852.038A.143.143,0,0,1,39.947,0Zm-19.8,51.492L39.6.662.362,37.519Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(98.667 275.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M19.883,0a.141.141,0,0,1,.108.049L40.351,24.193a.14.14,0,0,1-.028.206L.251,51.8a.132.132,0,0,1-.052.037.137.137,0,0,1-.111,0l0,0A.138.138,0,0,1,0,51.72a.14.14,0,0,1,.027-.1L19.752.09A.138.138,0,0,1,19.859,0ZM40.036,24.255,19.929.414.44,51.332Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(27.708 313.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M51.033,0a.139.139,0,0,1,.108.049A.14.14,0,0,1,51.158.2l-29.2,56.532a.14.14,0,0,1-.176.066l-.006,0a.144.144,0,0,1-.072-.064L.017,16.261a.137.137,0,0,1-.006-.12A.142.142,0,0,1,.1,16.06L50.992.007A.134.134,0,0,1,51.033,0Zm-29.2,56.374,28.924-56L.345,16.277Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(49.396 313.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M29.346,0a.145.145,0,0,1,.082.026L49.493,14.2a.142.142,0,0,1,.058.108.14.14,0,0,1-.048.113L.262,56.75a.14.14,0,0,1-.169.053l-.006,0A.142.142,0,0,1,0,56.694a.144.144,0,0,1,.038-.121L29.222.076A.138.138,0,0,1,29.313,0,.16.16,0,0,1,29.346,0ZM49.183,14.325,29.4.348.61,56.082Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(0 329.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M27.849,0a.138.138,0,0,1,.085.029.142.142,0,0,1,.051.149L16.67,41.353a.141.141,0,0,1-.223.072l0,0a.135.135,0,0,1-.029-.033L.023,16.271A.139.139,0,0,1,0,16.162a.142.142,0,0,1,.067-.09L27.779.019A.141.141,0,0,1,27.849,0ZM16.482,40.979,27.623.435.339,16.242Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(16.391 329.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M11.458,0a.142.142,0,0,1,.125.074L33.269,40.55a.136.136,0,0,1,0,.137.139.139,0,0,1-.118.07l-32.976.7a.143.143,0,0,1-.116-.028l0,0a.139.139,0,0,1-.045-.154l.009-.02L11.323.1a.139.139,0,0,1,.119-.1ZM32.913,40.481,11.5.517.33,41.169Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(482.617 14.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M52.851,0a.14.14,0,0,1,.134.184L38.671,44.256a.1.1,0,0,1-.017.035v0a.143.143,0,0,1-.1.061.136.136,0,0,1-.11-.029L.053,13.245A.14.14,0,0,1,.108,13L52.819,0A.108.108,0,0,1,52.851,0ZM38.466,43.978,52.64.337.449,13.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(521.012 14.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M14.456,0l.025,0A.141.141,0,0,1,14.6.145L14.055,18.1a.144.144,0,0,1-.017.061L.272,44.268l-.012.022v0a.141.141,0,0,1-.245-.137L14.323.1A.138.138,0,0,1,14.456,0Zm-.681,18.062.511-16.943L.783,42.7Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(471.195 27.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M11.563,0a.138.138,0,0,1,.088.03l38.4,31.08a.143.143,0,0,1,.047.148.14.14,0,0,1-.118.1L.162,37.68a.165.165,0,0,1-.125-.056A.151.151,0,0,1,0,37.5L11.428.1a.139.139,0,0,1,.093-.093A.168.168,0,0,1,11.563,0Zm38.05,31.122L11.636.381.335,37.376Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(411.02 47.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M37.676,0a.141.141,0,0,1,.133.189l-25.265,69.4a.263.263,0,0,1-.016.03h0a.141.141,0,0,1-.249-.03L.008,35.232a.143.143,0,0,1,.037-.151L37.58.038A.138.138,0,0,1,37.676,0ZM12.412,69.129,37.344.643.3,35.224Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(423.289 47.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M25.406,0a.138.138,0,0,1,.088.03L48.138,17.9a.133.133,0,0,1,.053.1.139.139,0,0,1-.037.107L.243,69.638a.139.139,0,0,1-.189.015.141.141,0,0,1-.042-.169L25.275.092a.141.141,0,0,1,.093-.087A.151.151,0,0,1,25.406,0ZM47.845,18.027,25.473.371.51,68.938Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(385.41 82.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M25.75,0h.01a.141.141,0,0,1,.122.093L38.152,34.452a.141.141,0,0,1-.084.18L.213,48.3a.139.139,0,0,1-.137,0,.138.138,0,0,1-.061-.187v0l0-.009L25.626.074A.14.14,0,0,1,25.75,0Zm12.09,34.415L25.725.487.438,47.918Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(328.262 95.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M43.184,0a.141.141,0,0,1,.138.167L30.838,65.841a.141.141,0,0,1-.26.064L.022,17.11a.137.137,0,0,1-.015-.118A.141.141,0,0,1,.089,16.9L43.132.01A.142.142,0,0,1,43.184,0ZM30.626,65.451,43,.365.35,17.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(358.819 95.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M12.627,0a.14.14,0,0,1,.13.089L26.864,35.05a.144.144,0,0,1-.024.145L.247,65.923A.142.142,0,0,1,0,65.8L12.49.115A.139.139,0,0,1,12.613,0ZM26.571,35.075,12.676.637.375,65.345Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(314.769 112.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M13.634,0a.145.145,0,0,1,.119.065l30.557,48.8a.14.14,0,0,1-.1.214L.2,55.906a.128.128,0,0,1-.08.006l-.008,0A.139.139,0,0,1,0,55.768a.134.134,0,0,1,.021-.07L13.5.107A.142.142,0,0,1,13.611,0ZM43.959,48.829,13.691.5.334,55.6Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(279.647 118.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M19.172,0a.144.144,0,0,1,.081.026.141.141,0,0,1,.057.138L7.123,74.286a.14.14,0,0,1-.278.021l0-.017L0,10.82a.14.14,0,0,1,.072-.137L19.1.018A.148.148,0,0,1,19.172,0ZM7.012,73.234,18.986.406.291,10.882Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(286.489 118.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M12.33,0a.141.141,0,0,1,.134.1l16.09,49.93a.141.141,0,0,1-.043.15L.232,74.387a.141.141,0,0,1-.137.026A.139.139,0,0,1,0,74.308a.167.167,0,0,1,0-.053L12.191.118A.141.141,0,0,1,12.32,0ZM28.257,50.025,12.374.737.341,73.924Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(219.604 128.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M60.184,0a.142.142,0,0,1,.075.021.138.138,0,0,1,.063.139L48.254,80.092a.141.141,0,0,1-.117.118.143.143,0,0,1-.128-.047L.051,40.277a.141.141,0,0,1,.011-.225L60.106.024A.132.132,0,0,1,60.184,0ZM48.014,79.8,60,.433.376,40.182Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(267.577 128.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M12.211,0h0a.14.14,0,0,1,.137.125L19.193,63.6a.142.142,0,0,1-.048.12L.259,80.149a.143.143,0,0,1-.094.061.142.142,0,0,1-.147-.076l0,0a.142.142,0,0,1-.007-.111L12.072.119A.14.14,0,0,1,12.211,0Zm6.694,63.559L12.188,1.235.34,79.706Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(210.517 168.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M9.227,0a.137.137,0,0,1,.09.033l47.973,39.9a.142.142,0,0,1,.048.13.14.14,0,0,1-.087.108L.193,63.16a.134.134,0,0,1-.117-.006A.135.135,0,0,1,0,63.061.158.158,0,0,1,0,63L9.088.12A.14.14,0,0,1,9.177.009.149.149,0,0,1,9.227,0Zm47.7,40L9.33.409.314,62.809Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(113.586 214.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M35.445,0A.139.139,0,0,1,35.5.012a.136.136,0,0,1,.082.1L46.529,50.549a.147.147,0,0,1,0,.066v.007a.139.139,0,0,1-.085.093.137.137,0,0,1-.125-.011L.066,21.886a.14.14,0,0,1,0-.238L35.371.021A.145.145,0,0,1,35.445,0Zm10.74,50.291L35.35.364.408,21.768Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(148.89 214.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M.141,0A.14.14,0,0,1,.2.013L48.742,22.875a.14.14,0,0,1,.022.24L11.168,50.7a.142.142,0,0,1-.163,0,.14.14,0,0,1-.061-.113L0,.171A.137.137,0,0,1,.053.031.142.142,0,0,1,.141,0ZM48.409,23.028.339.39l10.84,49.952Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(113.586 236.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M.14,0A.136.136,0,0,1,.215.021L46.464,28.84a.14.14,0,0,1-.039.255L5.03,39.793l-.024.009a.137.137,0,0,1-.166-.072l0,0a.163.163,0,0,1-.015-.065L0,.157A.138.138,0,0,1,.064.022.135.135,0,0,1,.14,0Zm45.9,28.9L.316.415,5.085,39.489Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(61.052 254.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M46.8,0a.14.14,0,0,1,.126.2l-29.1,58.769a.142.142,0,0,1-.082.071h0a.141.141,0,0,1-.109-.008.137.137,0,0,1-.07-.084L.006,1.263a.142.142,0,0,1,.021-.124.138.138,0,0,1,.11-.058L46.8,0ZM17.723,58.537,46.572.287.328,1.358Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(78.601 254.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M29.25,0a.14.14,0,0,1,.126.078l10.7,21.378a.14.14,0,0,1-.029.165L.258,58.994a.132.132,0,0,1-.069.049h0a.14.14,0,0,1-.153-.222L29.125.078A.141.141,0,0,1,29.25,0ZM39.776,21.488,29.252.455.62,58.269Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(27.704 255.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M33.489,0H33.5a.138.138,0,0,1,.125.1l17.55,57.689a.141.141,0,0,1-.092.175L.188,74.019a.141.141,0,0,1-.065,0,.153.153,0,0,1-.1-.073.144.144,0,0,1-.007-.125L33.361.083A.14.14,0,0,1,33.489,0ZM50.863,57.739,33.463.538.394,73.658Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M2.3,4.6A2.3,2.3,0,1,0,0,2.3,2.3,2.3,0,0,0,2.3,4.6Z",
    transform: "translate(723.652 111.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M1.434,2.868A1.434,1.434,0,1,0,0,1.434,1.434,1.434,0,0,0,1.434,2.868Z",
    transform: "translate(745.172 130.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M1.169,2.338A1.169,1.169,0,1,0,0,1.169,1.169,1.169,0,0,0,1.169,2.338Z",
    transform: "translate(695.269 178.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M3.049,6.1A3.049,3.049,0,1,0,0,3.049,3.049,3.049,0,0,0,3.049,6.1Z",
    transform: "translate(666.249 144.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M1.7,3.4A1.7,1.7,0,1,0,0,1.7,1.7,1.7,0,0,0,1.7,3.4Z",
    transform: "translate(689.471 146.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 1.568,
    cy: 1.568,
    rx: 1.568,
    ry: 1.568,
    transform: "translate(622.106 201.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 1.46,
    cy: 1.46,
    rx: 1.46,
    ry: 1.46,
    transform: "translate(674.361 191.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M0,3.1A3.1,3.1,0,1,0,3.1,0,3.1,3.1,0,0,0,0,3.1Z",
    transform: "translate(530.258 208.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 3.627,
    cy: 3.627,
    rx: 3.627,
    ry: 3.627,
    transform: "translate(564.565 245.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 1.057,
    cy: 1.057,
    rx: 1.057,
    ry: 1.057,
    transform: "translate(524.455 277.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.597,
    cy: 1.597,
    rx: 1.597,
    ry: 1.597,
    transform: "translate(458.113 325.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1.694,3.386A1.693,1.693,0,1,0,0,1.694,1.693,1.693,0,0,0,1.694,3.386Z",
    transform: "translate(433.525 328.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M2.168,4.336A2.168,2.168,0,1,0,0,2.168,2.168,2.168,0,0,0,2.168,4.336Z",
    transform: "translate(390.148 356.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 2.158,
    cy: 2.158,
    rx: 2.158,
    ry: 2.158,
    transform: "translate(335.381 364.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M2.669,5.338A2.669,2.669,0,1,0,0,2.669,2.669,2.669,0,0,0,2.669,5.338Z",
    transform: "translate(363.582 308.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M1.8,0a1.8,1.8,0,1,0,1.8,1.8A1.8,1.8,0,0,0,1.8,0Z",
    transform: "translate(286.282 419.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M0,1.442A1.441,1.441,0,1,0,1.442,0,1.441,1.441,0,0,0,0,1.442Z",
    transform: "translate(321.344 400.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M1.751,3.5A1.751,1.751,0,1,0,0,1.751,1.751,1.751,0,0,0,1.751,3.5Z",
    transform: "translate(235.308 401.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M2.454,4.908A2.454,2.454,0,1,0,0,2.453,2.454,2.454,0,0,0,2.454,4.908Z",
    transform: "translate(183.465 479.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 2.068,
    cy: 2.068,
    rx: 2.068,
    ry: 2.068,
    transform: "translate(193.312 466.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M1.9,3.807A1.9,1.9,0,1,0,0,1.9,1.9,1.9,0,0,0,1.9,3.807Z",
    transform: "translate(188.975 422.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M2.223,4.446A2.223,2.223,0,1,0,0,2.223,2.222,2.222,0,0,0,2.223,4.446Z",
    transform: "translate(95.3 502.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M2.518,5.038A2.519,2.519,0,1,0,0,2.518,2.52,2.52,0,0,0,2.518,5.038Z",
    transform: "translate(154.136 492.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M1.861,3.723A1.862,1.862,0,1,0,0,1.861,1.862,1.862,0,0,0,1.861,3.723Z",
    transform: "translate(678.762 100.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M2.808,5.615A2.808,2.808,0,1,0,0,2.808,2.808,2.808,0,0,0,2.808,5.615Z",
    transform: "translate(629.781 181.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1.791,3.581A1.791,1.791,0,1,0,0,1.791,1.79,1.79,0,0,0,1.791,3.581Z",
    transform: "translate(581.808 203.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M2.439,4.876A2.438,2.438,0,1,0,0,2.439,2.438,2.438,0,0,0,2.439,4.876Z",
    transform: "translate(584.762 149.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M2.049,4.1A2.049,2.049,0,1,0,0,2.049,2.05,2.05,0,0,0,2.049,4.1Z",
    transform: "translate(547.375 164.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M3,5.992A3,3,0,1,0,0,3,3,3,0,0,0,3,5.992Z",
    transform: "translate(508.072 244.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M1.549,3.1A1.549,1.549,0,1,0,0,1.549,1.55,1.55,0,0,0,1.549,3.1Z",
    transform: "translate(495.529 188.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M2.647,5.292A2.646,2.646,0,1,0,0,2.646,2.645,2.645,0,0,0,2.647,5.292Z",
    transform: "translate(469.407 264.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M2.191,4.382A2.191,2.191,0,1,0,0,2.19,2.191,2.191,0,0,0,2.191,4.382Z",
    transform: "translate(417.638 272.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M0,2.72A2.72,2.72,0,1,0,2.72,0,2.719,2.719,0,0,0,0,2.72Z",
    transform: "translate(402.487 303.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M2.342,0A2.343,2.343,0,1,0,4.684,2.342,2.342,2.342,0,0,0,2.342,0Z",
    transform: "translate(315.398 347.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M3.5,0A3.5,3.5,0,1,0,7,3.5,3.5,3.5,0,0,0,3.5,0Z",
    transform: "translate(284.982 348.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M.734,1.468A.734.734,0,1,0,0,.734.734.734,0,0,0,.734,1.468Z",
    transform: "translate(264.278 385.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M1.977,3.951A1.976,1.976,0,1,0,0,1.976,1.975,1.975,0,0,0,1.977,3.951Z",
    transform: "translate(276.25 331.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M1.125,2.251A1.125,1.125,0,1,0,0,1.125,1.127,1.127,0,0,0,1.125,2.251Z",
    transform: "translate(167.06 436.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M3.106,6.211A3.106,3.106,0,1,0,0,3.106,3.105,3.105,0,0,0,3.106,6.211Z",
    transform: "translate(126.124 453.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M0,3.016A3.016,3.016,0,1,0,3.016,0,3.016,3.016,0,0,0,0,3.016Z",
    transform: "translate(119.228 416.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M2.393,4.787A2.394,2.394,0,1,0,0,2.394,2.393,2.393,0,0,0,2.393,4.787Z",
    transform: "translate(68.92 499.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M3.783,7.566A3.783,3.783,0,1,0,0,3.783,3.784,3.784,0,0,0,3.783,7.566Z",
    transform: "translate(602.41 86.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M1.281,3.172A1.6,1.6,0,0,0,3.206,1.6,1.6,1.6,0,1,0,1.281,3.172Z",
    transform: "translate(617.952 120.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M2.158,4.315A2.158,2.158,0,1,0,0,2.158,2.158,2.158,0,0,0,2.158,4.315Z",
    transform: "translate(563.542 110.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M1.533,3.068A1.534,1.534,0,1,0,0,1.534,1.534,1.534,0,0,0,1.533,3.068Z",
    transform: "translate(544.342 136.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 1.278,
    cy: 1.278,
    rx: 1.278,
    ry: 1.278,
    transform: "translate(526.201 169.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 2.567,
    cy: 2.567,
    rx: 2.567,
    ry: 2.567,
    transform: "translate(501.355 166.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M0,2.255A2.256,2.256,0,1,0,2.257,0,2.256,2.256,0,0,0,0,2.255Z",
    transform: "translate(449.579 165.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.77,
    cy: 1.77,
    rx: 1.77,
    ry: 1.77,
    transform: "translate(452.194 217.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M1.67,0A1.67,1.67,0,1,0,3.34,1.67,1.67,1.67,0,0,0,1.67,0Z",
    transform: "translate(422.049 253.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M0,1.319A1.319,1.319,0,1,0,1.319,0,1.318,1.318,0,0,0,0,1.319Z",
    transform: "translate(403.19 264.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M0,1.835A1.836,1.836,0,1,0,1.836,0,1.836,1.836,0,0,0,0,1.835Z",
    transform: "translate(381.371 212.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M2.949,5.9A2.948,2.948,0,1,0,0,2.949,2.947,2.947,0,0,0,2.949,5.9Z",
    transform: "translate(336.47 290.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 1.768,
    cy: 1.768,
    rx: 1.768,
    ry: 1.768,
    transform: "translate(305.277 311.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M1.613,3.225A1.613,1.613,0,1,0,0,1.613,1.612,1.612,0,0,0,1.613,3.225Z",
    transform: "translate(248.127 287.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M2.325,4.65A2.325,2.325,0,1,0,0,2.325,2.325,2.325,0,0,0,2.325,4.65Z",
    transform: "translate(257.831 339.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M1.535,3.069A1.535,1.535,0,1,0,0,1.534,1.535,1.535,0,0,0,1.535,3.069Z",
    transform: "translate(216.118 366.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M0,2.307A2.307,2.307,0,1,0,2.306,0,2.306,2.306,0,0,0,0,2.307Z",
    transform: "translate(150.018 384.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M0,1.779A1.779,1.779,0,1,0,1.779,0,1.779,1.779,0,0,0,0,1.779Z",
    transform: "translate(80.13 434.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M2.559,5.119A2.559,2.559,0,1,0,0,2.56,2.558,2.558,0,0,0,2.559,5.119Z",
    transform: "translate(57.019 408.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 1.844,
    cy: 1.844,
    rx: 1.844,
    ry: 1.844,
    transform: "translate(73.499 450.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M2.634,5.268A2.634,2.634,0,1,0,0,2.634,2.633,2.633,0,0,0,2.634,5.268Z",
    transform: "translate(608.633 53.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M1.095,0A1.094,1.094,0,1,0,2.188,1.093,1.094,1.094,0,0,0,1.095,0Z",
    transform: "translate(645.066 54.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M2.164,4.331A2.165,2.165,0,1,0,0,2.165,2.165,2.165,0,0,0,2.164,4.331Z",
    transform: "translate(644.503 27.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M2.272,4.545A2.272,2.272,0,1,0,0,2.272,2.272,2.272,0,0,0,2.272,4.545Z",
    transform: "translate(527.189 89.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M0,1.322A1.321,1.321,0,1,0,1.322,0,1.321,1.321,0,0,0,0,1.322Z",
    transform: "translate(484.759 103.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M1.4,0A1.4,1.4,0,1,0,2.8,1.4,1.4,1.4,0,0,0,1.4,0Z",
    transform: "translate(425.385 197.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 3.277,
    cy: 3.277,
    rx: 3.277,
    ry: 3.277,
    transform: "translate(375.887 181.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(370.896 228.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M3.013,6.027A3.013,3.013,0,1,0,0,3.014,3.012,3.012,0,0,0,3.013,6.027Z",
    transform: "translate(353.415 180.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M0,1.916A1.916,1.916,0,1,0,1.916,0,1.916,1.916,0,0,0,0,1.916Z",
    transform: "translate(282.062 270.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M2.791,5.583A2.791,2.791,0,1,0,0,2.791,2.791,2.791,0,0,0,2.791,5.583Z",
    transform: "translate(318.166 248.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 3.288,
    cy: 3.288,
    rx: 3.288,
    ry: 3.288,
    transform: "translate(194.941 289.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1.615,3.229A1.614,1.614,0,1,0,0,1.615,1.615,1.615,0,0,0,1.615,3.229Z",
    transform: "translate(212.94 333.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 1.189,
    cy: 1.189,
    rx: 1.189,
    ry: 1.189,
    transform: "translate(170.193 335.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 1.627,
    cy: 1.627,
    rx: 1.627,
    ry: 1.627,
    transform: "translate(157.142 344.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M3.12,6.239A3.12,3.12,0,1,0,0,3.12,3.12,3.12,0,0,0,3.12,6.239Z",
    transform: "translate(96.751 325.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M2.872,5.743A2.871,2.871,0,1,0,0,2.871,2.871,2.871,0,0,0,2.872,5.743Z",
    transform: "translate(137.102 298.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M0,3.122A3.121,3.121,0,1,0,3.122,0,3.121,3.121,0,0,0,0,3.122Z",
    transform: "translate(108.791 364.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1.644,3.288A1.644,1.644,0,1,0,0,1.644,1.644,1.644,0,0,0,1.644,3.288Z",
    transform: "translate(48.956 369.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 1.853,
    cy: 1.853,
    rx: 1.853,
    ry: 1.853,
    transform: "translate(15.743 370.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1.21,2.421A1.21,1.21,0,1,0,0,1.21,1.21,1.21,0,0,0,1.21,2.421Z",
    transform: "translate(73.588 391.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1.707,3.416A1.708,1.708,0,1,0,0,1.708,1.708,1.708,0,0,0,1.707,3.416Z",
    transform: "translate(578.904 17.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1.839,3.676A1.838,1.838,0,1,0,0,1.837,1.838,1.838,0,0,0,1.839,3.676Z",
    transform: "translate(613.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1.068,2.137A1.069,1.069,0,1,0,0,1.069,1.068,1.068,0,0,0,1.068,2.137Z",
    transform: "translate(555.919 64.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1.186,2.371A1.186,1.186,0,1,0,0,1.186,1.185,1.185,0,0,0,1.186,2.371Z",
    transform: "translate(534.805 33.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M2.777,5.554A2.777,2.777,0,1,0,0,2.777,2.777,2.777,0,0,0,2.777,5.554Z",
    transform: "translate(440.297 145.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1.314,2.627A1.314,1.314,0,1,0,0,1.314,1.313,1.313,0,0,0,1.314,2.627Z",
    transform: "translate(385.302 130.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M3.917,7.835A3.917,3.917,0,1,0,0,3.917,3.918,3.918,0,0,0,3.917,7.835Z",
    transform: "translate(420.576 114.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M2.413,4.827A2.413,2.413,0,1,0,0,2.413,2.414,2.414,0,0,0,2.413,4.827Z",
    transform: "translate(400.014 147.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 2.616,
    cy: 2.616,
    rx: 2.616,
    ry: 2.616,
    transform: "translate(313.052 213.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M2.3,4.6A2.3,2.3,0,1,0,0,2.3,2.3,2.3,0,0,0,2.3,4.6Z",
    transform: "translate(228.035 248.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M0,3.568A3.569,3.569,0,1,0,3.568,0,3.568,3.568,0,0,0,0,3.568Z",
    transform: "translate(285.737 234.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M0,2.216A2.216,2.216,0,1,0,2.216,0,2.216,2.216,0,0,0,0,2.216Z",
    transform: "translate(160.714 285.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1.393,2.787A1.393,1.393,0,1,0,0,1.394,1.393,1.393,0,0,0,1.393,2.787Z",
    transform: "translate(197.242 237.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1.627,3.254A1.627,1.627,0,1,0,0,1.627,1.628,1.628,0,0,0,1.627,3.254Z",
    transform: "translate(159.411 265.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1.63,3.26A1.63,1.63,0,1,0,0,1.631,1.63,1.63,0,0,0,1.63,3.26Z",
    transform: "translate(117.983 275.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 2.026,
    cy: 2.026,
    rx: 2.026,
    ry: 2.026,
    transform: "translate(77.78 312.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1.2,2.406A1.2,1.2,0,1,0,0,1.2,1.2,1.2,0,0,0,1.2,2.406Z",
    transform: "translate(0 345.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 1.743,
    cy: 1.743,
    rx: 1.743,
    ry: 1.743,
    transform: "translate(520.474 58.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.638,
    cy: 2.638,
    rx: 2.638,
    ry: 2.638,
    transform: "translate(481.184 27.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 0.858,
    cy: 0.858,
    rx: 0.858,
    ry: 0.858,
    transform: "translate(535.674 15.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1.809,3.619A1.809,1.809,0,1,0,0,1.809,1.81,1.81,0,0,0,1.809,3.619Z",
    transform: "translate(470.588 65.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M1.69,3.381A1.691,1.691,0,1,0,0,1.691,1.691,1.691,0,0,0,1.69,3.381Z",
    transform: "translate(410.534 82.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M1.7,3.4A1.7,1.7,0,1,0,0,1.7,1.7,1.7,0,0,0,1.7,3.4Z",
    transform: "translate(448.059 47.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M1.189,2.378A1.189,1.189,0,1,0,0,1.189,1.189,1.189,0,0,0,1.189,2.378Z",
    transform: "translate(328.276 113.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 1.496,
    cy: 1.496,
    rx: 1.496,
    ry: 1.496,
    transform: "translate(371.014 95.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M1.54,3.08A1.54,1.54,0,1,0,0,1.541,1.54,1.54,0,0,0,1.54,3.08Z",
    transform: "translate(358.483 161.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M3.7,7.392A3.7,3.7,0,1,0,0,3.7,3.7,3.7,0,0,0,3.7,7.392Z",
    transform: "translate(283.997 190.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1.8,3.608A1.8,1.8,0,1,0,0,1.8,1.8,1.8,0,0,0,1.8,3.608Z",
    transform: "translate(279.047 128.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 0.858,
    cy: 0.858,
    rx: 0.858,
    ry: 0.858,
    transform: "translate(299.024 119.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M2.125,4.25A2.125,2.125,0,1,0,0,2.125,2.126,2.126,0,0,0,2.125,4.25Z",
    transform: "translate(313.848 167.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M2.349,4.7A2.349,2.349,0,1,0,0,2.349,2.349,2.349,0,0,0,2.349,4.7Z",
    transform: "translate(266.434 208.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M1.687,3.374A1.687,1.687,0,1,0,0,1.687,1.688,1.688,0,0,0,1.687,3.374Z",
    transform: "translate(219.121 168.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1.691,3.383A1.691,1.691,0,1,0,0,1.691,1.692,1.692,0,0,0,1.691,3.383Z",
    transform: "translate(210.029 231.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 1.187,
    cy: 1.187,
    rx: 1.187,
    ry: 1.187,
    transform: "translate(148.907 215.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M.789,1.578A.789.789,0,1,0,0,.789.789.789,0,0,0,.789,1.578Z",
    transform: "translate(114.001 237.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 1.461,
    cy: 1.461,
    rx: 1.461,
    ry: 1.461,
    transform: "translate(60.795 255.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M2.653,5.307A2.653,2.653,0,1,0,0,2.653,2.653,2.653,0,0,0,2.653,5.307Z",
    transform: "translate(106.262 253.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M1.97,3.939A1.969,1.969,0,1,0,0,1.969,1.97,1.97,0,0,0,1.97,3.939Z",
    transform: "translate(26.942 328.944)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapemainsection);
export default __webpack_public_path__ + "static/media/Shapemainsection.e91944702a3383aaeed88a18b6ea18f0.svg";
export { ForwardRef as ReactComponent };